<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse pt-0">
        <TableButtonComp
          normalButton
          iconBut="fas fa-plus"
          textButton="Crear tipo de licencia"
          @click="addItem"
        />
      </v-col>
    </v-row>
    <!-- consultar -->
    <ComundataTableComp
      placeholderTextsearch="Bucar tipos de licencias"
      rowsPerPageText="Tipos por página:"
      noResultsText="Sin tipos de licencias por mostrar"
      whitSearch
      :headers="LicenciatipoHeaders"
      :items="Datos"
    >
      <template v-slot:estadoValor="{ item }">
        <v-chip
          small
          :class="item.estado === 1 ? 'color_activo' : 'color_inactivo'"
        >
          {{ item.estado === 1 ? "Activo" : "Cerrado" }}
        </v-chip>
      </template>

      <template v-slot:action_editar="{ item }">
        <TableButtonComp
          v-if="componenteEvento.editar_submodulo"
          editButton
          @click="editItem(item)"
          tooltipText="Editar tipo de licencia"
        />
      </template>

      <template v-slot:action_borrar="{ item }">
        <TableButtonComp
          v-if="componenteEvento.borrar_submodulo"
          deleteButton
          @click="deleted(item.id)"
          tooltipText="Borrar tipo de licencia"
        />
      </template>
    </ComundataTableComp>

    <!-- Modal -->
    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="dialog" persistent scrollable max-width="600px">
        <v-card>
          <v-card-title class="btn_otro">
            <label>{{ formTitle }}</label>
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="dialog = false"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <br>  
            <v-row>
              <v-col cols="12" sm="12" md="12" class="py-0">
                <v-autocomplete
                  label="Colegio"
                  v-model="editedItem.id_colegio"
                  :items="colegios"
                  item-value="id"
                  item-text="nombre_colegio"
                  prepend-icon="fa-school"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" class="py-0">
                <v-text-field
                  v-model="editedItem.desc_tipo_licencia"
                  label="Nombre"
                  :rules="[rul.required]"
                  prepend-icon="fa-id-badge"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" class="py-0">
                <v-text-field
                  v-model="editedItem.duracion_licencia"
                  type="number"
                  label="Días de duración"
                  :rules="[rul.required,rul.nonNegative]"
                  prepend-icon="fas fa-calendar-day"
                  min="0"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" class="py-">
                <v-autocomplete
                  label="Rol de licencia"
                  dense
                  v-model="editedItem.id_rol_licencia"
                  :items="licenciasRoles"
                  item-value="id"
                  item-text="desc_rol_licencia"
                  prepend-icon="fas fa-user-shield"
                >
                </v-autocomplete>
              </v-col>


              <v-col cols="12" sm="6" class="">
                <label>
                  <v-icon left>mdi-information</v-icon> Estado:
                </label>
                <v-radio-group v-model="editedItem.estado" class="pl-8 mt-0">
                  <v-radio label="Activo" :value="1" color="teal"></v-radio>
                  <v-radio label="Inactivo" :value="0" color="error" ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" sm="6" class="" v-if="editedItem.id_rol_licencia == 1">
                <label>
                  <v-icon left>mdi-account-circle</v-icon> Permisos administrador:
                </label>
                <v-switch
                  v-model="editedItem.es_admin"
                  color="primary"
                ></v-switch>
              </v-col>

            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
          

            <v-btn
              class="btn_block_style2"
              :loading="loading"
              dark
              
              v-if="this.evento == 'editar'"
              @click="saveItem(editedItem.id)"
              >Guardar Cambios</v-btn
            >
            <v-btn
              class="btn_block_style2"
              :loading="loading"
              dark
              
              v-if="this.evento == 'agregar'"
              @click="saveItem"
              >Guardar</v-btn
            >

            <v-btn class="btn_style3" dark  @click="dialog = false"
              >Cancelar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- modal -->

    <confirm
      @aceptar="deleteItem"
      @cancelar="clear_confirm"
      :title="confirm.title"
      :titleWindow="confirm.titleWindow"
      :active="confirm.active"
    />
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { LicenciatipoHeaders } from "../../../../helpers/headersTable.js";
import ComundataTableComp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";

import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    ComundataTableComp,
    TableButtonComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 2, id_modulo: 4 }, //sud_modulo y modulo
    LicenciatipoHeaders,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    loading: false,
    dialog: false,
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },
    licenciasRoles:[],
    colegios: [],
    Datos: [],
    evento: null,

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      nonNegative: (value) => value >= 1 || "Debe ser igual o mayor a 1",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
    },

    editedItem: [],
    esAdmin: false
  }),

  computed: {
    formTitle() {
      return this.evento == "agregar"
        ? "Crear tipo de licencia"
        : "Editar tipo de licencia";
    },

    ...mapGetters("login", ["componenteEvento"]),
  },

  mounted() {
    this.getAll();
    this.getQuery();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    async limpiarForm() {
      this.loading = false;
      this.editedItem = {
        id_colegio: "",
        id_usuario: this.datoLogin.id,
        id: 0,
        cobrable_licencia: 0,
        estado: 1,
      };

      this.resetValidation();
    },

    filterKey(event) {
      // Si el código es menor que 48 (0) o mayor que 57 (9)
      if (
        event.keyCode == 69 ||
        event.keyCode == 190 ||
        event.keyCode == 189 ||
        event.keyCode == 187
      ) {
        //  // No se agrega
        //  if(event.keyCode != 8){
        event.preventDefault();
        //  }
      }
    },

    // Validar resetear campos al guardar
    resetValidation() {
      this.$refs.formDatos.resetValidation();
    },

    //  ------- MOSTRAR TODOS LOS REGISTROS    --------
    async getAll() {
      try {
        let response = await axios.get("/manager/licenciaTipo");
        
          const {datos,datosRoles } = response.data
          this.Datos = datos;
          this.licenciasRoles = datosRoles;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //----------- AREGAR REGISTROS  --------------
    async addItem() {
      this.evento = "agregar";
      this.dialog = true;
      this.limpiarForm();
    },

    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.titleWindow=""
      this.confirm.active = false;
    },
    //--------------EDITAR REGISTRO--------------
    editItem(item) {
      this.evento = "editar";
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async saveItem(id = "") {
      this.loading = true;
      this.editedItem.evento = this.evento;
      this.editedItem.es_admin =  this.editedItem.es_admin ? 1 : 0;
      
      if (this.$refs.formDatos.validate()) {

        // let rspta;
        try {
          //let params = this.editedItem
          if (this.evento == "agregar") {

            console.log('this.editedItem',this.editedItem);

            await axios.post("/manager/licenciaTipo", this.editedItem);
            //this.getAll()
          }

          if (this.evento == "editar") {
           await axios.put("/manager/licenciaTipo/" + id, this.editedItem);
            //this.getAll()
          }
          
          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Información creada con éxito!",
            tiempo: null,
          });

          this.getAll();
          this.dialog = false;
          this.limpiarForm();
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          //console.log(error);
        }
      }
    },

    //------------borrar nivel -------------
    async deleted(id) {
      this.confirm.id = id;
      this.confirm.title = "¿Está seguro de que desea borrar este registro?";
      this.confirm.titleWindow="Borrar tipo de licencia"
      this.confirm.active = true;

    },
    async deleteItem() {
      await axios
        .delete("/manager/licenciaTipo/" + this.confirm.id)
        .then((response) => {
          this.clear_confirm();
          if (response.data.error == 0) {
            this.getAll();
            this.dialog = false;
            this.setEnviarMens({
              tipo: "S",
              mensaje: response.data.message,
              tiempo: null,
            });
          }
          this.setEnviarMens({
            tipo: "E",
            mensaje: response.data.message,
            tiempo: null,
          });

          this.getAll();
        });
    },
    getQuery() {
      axios
        .get("/manager/licencia/getQuery")
        .then((response) => {
          this.colegios = response.data.colegio;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
          //console.log(e);
        });
    },
  },
};
</script>